import { useState } from 'react';
import {
    Grid,
    Button,
    CardMedia,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
} from '@mui/material';
import unsplash from '../../api/unsplash';
import { login } from '../../utils';
import { useNavigate } from 'react-router-dom';

import GlobalSnackbar from '../Snackbar';
import Safety from '../../assets/images/Safety_sx.jpeg';
import { Hidden } from '@mui/material';

const LoginLavoratore = () => {
    const [passwordShown, setPasswordShown] = useState(false);
    const [password, setPassword] = useState(null);
    const [username, setUsername] = useState(null);
    const [show2FA, setShow2FA] = useState(false);
    const [verificationCode, setVerificationCode] = useState('');
    const [pendingUser, setPendingUser] = useState(null);
    const [openSnack, setOpenSnack] = useState(false);
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    });
    const [icon, setIcon] = useState('bi bi-eye-slash-fill');

    const navigate = useNavigate();

    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };

    const handleEyeClick = () => {
        setPasswordShown(!passwordShown);
        setIcon(passwordShown ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill');
    };

    const finalizeLogin = async (u) => {
        login(null, u.token, 'lavoratore');
        sessionStorage.removeItem('Medico');
        sessionStorage.setItem('Nome', u.Nome);
        sessionStorage.setItem('Cognome', u.Cognome);
        sessionStorage.setItem('Mansione', u.DescMansione);
        sessionStorage.setItem('RagioneSociale', u.RagioneSociale);
        sessionStorage.setItem('DataAssunzione', u.DataAssunzione);
        sessionStorage.setItem('CF', u.CF);
        sessionStorage.setItem('Telefono', u.Telefono);
        sessionStorage.setItem('ID', u.ID);
        sessionStorage.setItem('FileAutoDelete', u.FileAutoDelete);
        sessionStorage.setItem('lavoratore', u.lavoratore);
        sessionStorage.setItem('TwoAuthenticate', u.TwoAuthenticate);
        sessionStorage.setItem('privacyPolicy', u.privacyPolicy);
        sessionStorage.setItem('NotificheAbilitate', u.NotificheAbilitate);

        navigate('/AreaLavoratore/Home');
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            let resp = await unsplash.post('portaleLavoratori/login', {
                username,
                password,
            });

            if (!resp.data.requires2FA) {
                const user = resp.data.user;
                await finalizeLogin(user);
                return;
            }

            setPendingUser({
                ID: resp.data.userID,
                Telefono: resp.data.telefono,
            });

            setShow2FA(true);
        } catch (e) {
            setSnack({
                severity: 'error',
                messaggio: 'UTENTE O PASSWORD ERRATE',
            });
            setOpenSnack(true);
        }
    };

    const handleConfirmCode = async () => {
        try {
            let resp = await unsplash.post(
                'portaleLavoratori/auth/verify-otp',
                {
                    userID: pendingUser.ID,
                    telefono: pendingUser.Telefono,
                    code: verificationCode,
                }
            );

            await finalizeLogin({
                ...resp.data.user,
                token: resp.data.token,
            });
        } catch (e) {
            setSnack({
                severity: 'error',
                messaggio: 'CODICE NON VALIDO',
            });
            setOpenSnack(true);
        }
    };

    const handleResetPassword = () => {
        navigate('/AreaLavoratore/reset-password');
    };

    return (
        <>
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                openSnack={openSnack}
                handleCloseSnack={handleCloseSnack}
            />
            <Grid
                container
                spacing={0}
                direction="row"
                alignItems="center"
                display="flex"
                minHeight="100vh"
                flexWrap="nowrap"
                className="bg-fixed bg-center bg-cover bg-sfondo dark:bg-none"
            >
                <Hidden mdDown>
                    <Grid
                        item
                        xs={6}
                        sx={{
                            margin: '30px',
                            borderRadius: '8px',
                        }}
                    >
                        <CardMedia
                            sx={{
                                borderRadius: '8px',
                                height: 'calc(100vh - 4rem)',
                            }}
                            component="img"
                            image={Safety}
                            alt="Safety"
                        />
                    </Grid>
                </Hidden>
                <Grid
                    item
                    xs={8}
                    lg={3}
                    justifyContent="center"
                    alignItems="center"
                    display="flex"
                    flexWrap="wrap"
                    gap={4}
                    style={{ margin: '0 auto' }}
                >
                    <img
                        src={require('../../assets/images/Logo-ASTM.png')}
                        className="h-auto max-w-full"
                        width="500px"
                        alt="f"
                    />

                    <form
                        //onSubmit={handleLogin}
                        style={{ width: '100%' }}
                    >
                        <label className="form-label fs-5" htmlFor="password">
                            Username
                        </label>
                        <div className="relative flex items-stretch w-full mb-4 form-outline">
                            <input
                                type="text"
                                id="username"
                                name="username"
                                placeholder="Inserisci username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                className="block w-full  px-4  py-2 mb-1  text-lg leading-normal text-gray-800 bg-white border border-r-0 border-gray-200 rounded appearance-none fs-6"
                            />
                        </div>

                        <label className="form-label fs-5" htmlFor="password">
                            Password
                        </label>
                        <div className="relative flex items-stretch w-full mb-4 form-outline">
                            <input
                                type={passwordShown ? 'text' : 'password'}
                                id="password"
                                name="password"
                                placeholder="Inserisci la password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="block w-full px-4 py-2 mb-1  text-lg leading-normal text-gray-800 bg-white border border-r-0 border-gray-200 rounded appearance-none fs-6"
                            />
                            <span className="bg-transparent input-group-text">
                                <i
                                    className={icon}
                                    style={{ cursor: 'pointer' }}
                                    onClick={handleEyeClick}
                                ></i>
                            </span>
                        </div>

                        <div className="flex items-center justify-around mb-4"></div>

                        <Button
                            type="submit"
                            fullWidth
                            size="large"
                            variant="contained"
                            onClick={handleLogin}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: '#11526f',
                                marginBottom: '10px',
                            }}
                        >
                            LOGIN
                        </Button>
                        <br></br>
                        <Button
                            type="button"
                            fullWidth
                            size="large"
                            variant="contained"
                            onClick={handleResetPassword}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: '#11526f',
                                marginTop: '10px',
                            }}
                        >
                            Reset Password{' '}
                        </Button>
                    </form>
                </Grid>
            </Grid>
            <Dialog
                open={show2FA}
                onClose={(event, reason) => {
                    if (
                        reason !== 'backdropClick' &&
                        reason !== 'escapeKeyDown'
                    ) {
                        setShow2FA(false);
                    }
                }}
            >
                <DialogTitle>Verifica SMS</DialogTitle>
                <DialogContent>
                    <p>
                        Abbiamo inviato un codice al numero associato al tuo
                        account.
                    </p>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Codice di verifica"
                        fullWidth
                        value={verificationCode}
                        onChange={(e) => setVerificationCode(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setShow2FA(false);
                        }}
                    >
                        Annulla
                    </Button>
                    <Button onClick={handleConfirmCode}>Conferma</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default LoginLavoratore;
